import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);


// primary: '#2D2926FF',
// secondary: '#FCF6F5FF',
// red: '#E94B3CFF',

// green: '#00ab55'